import * as React from "react";

import { IconButton, Tooltip } from "@material-ui/core";
import CasinoOutlined from "@material-ui/icons/CasinoOutlined";

import { IButtonProps } from "./IButtonProps";

import { Analytics } from "Utility/Analytics";
import { QuiltParamsHelper } from "Utility/QuiltParamsHelper";


export function RandomButton(props: IButtonProps): React.ReactElement {
    const onClick = () => {
        Analytics.generateQuilt();

        props.setParams(QuiltParamsHelper.regenerate(props.params));
    };

    return (
        <Tooltip title="Generate new quilt">
            <span>
                <IconButton size="small" color="primary" onClick={onClick} disabled={props.disabled}>
                    <CasinoOutlined/>
                </IconButton>
            </span>
        </Tooltip>
    )
}